import { FC } from "react";
import styles from './ProjectRow.module.scss';
import appState from "../../state/AppStateContainer";
import { useHistory } from "react-router-dom";

type Props = {
  symbol: string,
  name: string,
  areaName: string,
  purchasePhase: string,
  projectPhase: string,
  wonOrNot: string,
  slug: string,
  areaSlug: string,
}

const ProjectRow: FC<Props> = ({ symbol, name, areaName, purchasePhase, projectPhase, wonOrNot, slug, areaSlug }) => {
  const orgSlug = appState.getCurrentOrgSlug();
  const history = useHistory();
  const handleClick = () => {
    history.push(`/${orgSlug}/projects/${slug}/${areaSlug}`);
  };

  return (
    <div className={styles['project-row']} onClick={handleClick}>
      <div className={styles['project-row__name-symbol-holder']}>
        {symbol ? symbol : <div style={{ width: '18px', height: '18px' }}></div>}
        <div className={styles['project-row__name-holder']}>
          <span className={styles['project-row__name']}>{name}</span>
          {projectPhase ? <span className={styles['project-row__project-phase']}>{projectPhase}</span> : <div style={{ height: '17.16px' }}></div>}
        </div>
      </div>
      <div className={styles['project-row__area-phase-holder']}>
        <span className={styles['project-row__area-name']}>{areaName}</span>
        {purchasePhase ? <span className={styles['project-row__purchase-phase']}>{purchasePhase} {wonOrNot}</span> : <div style={{ height: '17.16px' }}></div>}
      </div>
    </div>
  )
};

export default ProjectRow;